<template>
  <div>
    <nav aria-label="breadcrumb" class="d-none d-lg-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item d-flex align-items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
            <path
                d="M1 5.8125L8.875 1L16.75 5.8125M15 8.875V14.475C15 14.765 14.765 15 14.475 15H3.275C2.98505 15 2.75 14.765 2.75 14.475V8.875"
                stroke="#0F1E2A" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item"><a href="#">Contact</a></li>
      </ol>
    </nav>

    <section class="connect-section">
      <div class="header">
        <h2 class="text-center">
          <span class="me-2">—</span>
          Become a SAFENET Reseller today!
          <span class="ms-2">—</span>
        </h2>
        <p class="text-center">We're here to help with your audio-visual and smart technology needs. For product info,
          support, or customization, contact us today!</p>
        <div class="icon d-flex justify-content-center gap-3">
          <a v-for="(icon, index) in socialIcons" :key="index" :href="icon.link">
            <component :is="icon.component"/>
          </a>
        </div>
      </div>

      <div class="mt-4 gap-5 gap-lg-0 d-flex flex-column flex-md-row justify-content-between"
           style="margin-bottom: 80px">
        <div v-for="(office, index) in offices" :key="index"
             class="corporate d-flex flex-column justify-content-between"
             style="gap: 20px">
          <h4>{{ office.title }}</h4>
          <div v-for="(detail, detailIndex) in office.details" :key="detailIndex" class="d-flex gap-3">
            <component :is="detail.icon"/>
            <div class="content_area" v-html="detail.content"></div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column flex-md-row mt-4 cp" style="gap: 80px">
        <div class="contact_side">
          <div style="margin-bottom: 40px;">
            <h4 class="with_us">Contact With Us</h4>
            <p class="with_descrip">
              Please submit all general enquiries in the contact form below and we look forward to hearing from you
              soon.
            </p>
          </div>

          <form @submit.prevent="submitForm">
            <div v-for="field in formFields" :key="field.id" class="form-group">
              <input v-if="field.type !== 'textarea'" :type="field.type" class="form-control" :id="field.id"
                     :placeholder="field.placeholder" v-model="formData[field.id]">
              <textarea v-else class="form-control" :id="field.id" rows="5" :placeholder="field.placeholder"
                        v-model="formData[field.id]"></textarea>
            </div>
            <button type="submit" class="send_btn">Send</button>
          </form>
        </div>
        <div class="map_side d-flex flex-column align-items-center gap-2">
          <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3651.9175410527264!2d90.38988616498135!3d23.75031973458935!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c74c270a01c7%3A0x5b6e8ed2da3eba30!2z4Kaw4Ka_4Kaa4Kau4Ka-4KaoIOCmh-CmqOCmq-CmsOCmruCnh-Cmn-Cmv-CmleCmuA!5e0!3m2!1sen!2sbd!4v1667970546018!5m2!1sen!2sbd"
              width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"
              referrerpolicy="no-referrer-when-downgrade">
          </iframe>
          <div class="d-flex align-items-center gap-3 mt-3">
            <a href="#" class="share text-decoration-none d-flex align-items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                <path
                    d="M7.05082 16.5L6.64148 17.1284L7.04557 17.3917L7.45273 17.1332L7.05082 16.5ZM1.00282 7.86263L0.253176 7.88587L1.00282 7.86263ZM13.0996 7.86263L12.35 7.83973L13.0996 7.86263ZM9.81733 8.03217C9.81733 6.50423 8.57913 5.26563 7.05161 5.26563V6.76563C7.75031 6.76563 8.31733 7.33226 8.31733 8.03217H9.81733ZM7.05161 5.26563C5.52347 5.26563 4.28507 6.50403 4.28507 8.03217H5.78507C5.78507 7.33246 6.35189 6.76563 7.05161 6.76563V5.26563ZM4.28507 8.03217C4.28507 9.5597 5.52366 10.7979 7.05161 10.7979V9.2979C6.35169 9.2979 5.78507 8.73087 5.78507 8.03217H4.28507ZM7.05161 10.7979C8.57894 10.7979 9.81733 9.5595 9.81733 8.03217H8.31733C8.31733 8.73107 7.75051 9.2979 7.05161 9.2979V10.7979ZM7.05082 16.5C7.46016 15.8716 7.46031 15.8717 7.46044 15.8717C7.46045 15.8717 7.46056 15.8718 7.46058 15.8718C7.46063 15.8719 7.4606 15.8718 7.46047 15.8718C7.46022 15.8716 7.45961 15.8712 7.45866 15.8706C7.45676 15.8693 7.45348 15.8672 7.44885 15.8641C7.4396 15.8579 7.42499 15.8482 7.40537 15.8349C7.36612 15.8083 7.30689 15.7676 7.23048 15.7134C7.07759 15.6052 6.85638 15.4436 6.58929 15.2343C6.05398 14.8149 5.34023 14.2085 4.62433 13.4607C3.16673 11.9381 1.81794 9.95154 1.75246 7.83939L0.253176 7.88587C0.336343 10.5685 2.01155 12.9006 3.5408 14.498C4.31831 15.3102 5.08869 15.9641 5.66415 16.415C5.95245 16.6409 6.1933 16.817 6.36361 16.9376C6.4488 16.9979 6.51645 17.0445 6.5637 17.0765C6.58732 17.0925 6.60585 17.1049 6.61893 17.1136C6.62547 17.1179 6.63065 17.1213 6.63442 17.1238C6.63631 17.1251 6.63784 17.1261 6.63902 17.1268C6.63961 17.1272 6.64011 17.1275 6.64052 17.1278C6.64072 17.1279 6.64096 17.1281 6.64107 17.1282C6.64128 17.1283 6.64148 17.1284 7.05082 16.5ZM1.75246 7.83939C1.66067 4.87869 4.15045 2.25 7.05082 2.25V0.75C3.26987 0.75 0.136216 4.11325 0.253176 7.88587L1.75246 7.83939ZM7.05082 2.25C9.95102 2.25 12.4404 4.87854 12.35 7.83973L13.8493 7.88553C13.9645 4.11331 10.8319 0.75 7.05082 0.75V2.25ZM12.35 7.83973C12.2839 10.0024 10.9328 11.9893 9.47946 13.4954C8.76459 14.2362 8.05191 14.8328 7.51747 15.2442C7.25082 15.4494 7.03004 15.6074 6.87753 15.713C6.80131 15.7658 6.74226 15.8055 6.7032 15.8313C6.68367 15.8442 6.66914 15.8537 6.65997 15.8596C6.65539 15.8626 6.65215 15.8647 6.65029 15.8659C6.64936 15.8665 6.64878 15.8669 6.64854 15.867C6.64843 15.8671 6.6484 15.8671 6.64846 15.8671C6.64849 15.867 6.64861 15.867 6.64862 15.867C6.64875 15.8669 6.64891 15.8668 7.05082 16.5C7.45273 17.1332 7.45293 17.1331 7.45316 17.133C7.45326 17.1329 7.45351 17.1327 7.45372 17.1326C7.45414 17.1323 7.45465 17.132 7.45525 17.1316C7.45644 17.1309 7.458 17.1299 7.45991 17.1286C7.46372 17.1262 7.46894 17.1228 7.47552 17.1186C7.48869 17.11 7.50731 17.0979 7.53102 17.0822C7.57844 17.0508 7.64628 17.0052 7.73167 16.9461C7.90236 16.8278 8.14363 16.6551 8.43238 16.4328C9.00873 15.9892 9.78021 15.3439 10.5589 14.537C12.0925 12.9477 13.7658 10.6159 13.8493 7.88553L12.35 7.83973Z"
                    fill="#424242"/>
              </svg>
              Share Location
            </a>
            <a v-for="(icon, index) in socialtwoIcons" :key="index" :href="icon.link">
              <component :is="icon.component"/>
            </a>
          </div>
        </div>

      </div>
    </section>

  </div>
</template>

<script setup>
import {ref} from 'vue';

const FacebookIcon = {
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <circle cx="15" cy="15" r="14.5" stroke="#4A4A4A"/>
  <path d="M16.2191 15.6139V21.5H14.649V15.6139V15.1139H14.149H12.5V13.6252H14.149H14.649V13.1252V11.2898C14.649 10.3282 14.9403 9.64471 15.3885 9.20176C15.8382 8.75729 16.5015 8.5 17.35 8.5C17.9108 8.5 18.4196 8.5264 18.7704 8.5527V9.82422L17.9526 9.82459C17.9525 9.82459 17.9524 9.82459 17.9524 9.82459C17.3692 9.82462 16.882 9.96261 16.5659 10.3381C16.2659 10.6944 16.2191 11.1545 16.2191 11.5362V13.1252V13.6252H16.7191H18.615L18.4231 15.1139H16.7191H16.2191V15.6139Z" fill="#4A4A4A" stroke="#4A4A4A"/>
</svg>
  `
}
const YoutubeIcon = {
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <path d="M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15ZM1.00038 15C1.00038 22.7318 7.26822 28.9996 15 28.9996C22.7318 28.9996 28.9996 22.7318 28.9996 15C28.9996 7.26822 22.7318 1.00038 15 1.00038C7.26822 1.00038 1.00038 7.26822 1.00038 15Z" fill="#4A4A4A"/>
  <path d="M19.3845 10.003H10.6155C8.895 10.003 7.5 11.383 7.5 13.084V17.419C7.5 19.1215 8.895 20.5 10.6155 20.5H19.3845C21.105 20.5 22.5 19.12 22.5 17.419V13.084C22.5 11.3815 21.105 10.003 19.3845 10.003ZM17.2785 15.463L13.176 17.398C13.1509 17.4099 13.1232 17.4152 13.0955 17.4135C13.0678 17.4118 13.041 17.4032 13.0175 17.3884C12.994 17.3736 12.9746 17.3531 12.9612 17.3288C12.9477 17.3045 12.9406 17.2773 12.9405 17.2495V13.2595C12.9408 13.2314 12.9482 13.2038 12.9621 13.1794C12.976 13.1549 12.9959 13.1344 13.02 13.1199C13.044 13.1053 13.0714 13.0971 13.0995 13.0961C13.1276 13.095 13.1555 13.1012 13.1805 13.114L17.2815 15.169C17.3085 15.1831 17.331 15.2044 17.3466 15.2305C17.3623 15.2566 17.3704 15.2865 17.3701 15.3169C17.3698 15.3473 17.361 15.3771 17.3449 15.4029C17.3287 15.4287 17.3057 15.4495 17.2785 15.463Z" fill="#4A4A4A"/>
</svg>
  `
}

const LinkedinIcon = {
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <circle cx="15" cy="15" r="14.5" stroke="#1E1E1E"/>
  <mask id="path-2-inside-1_314_1514" fill="white">
    <path d="M21.9965 22L22 21.9994V16.8649C22 14.3531 21.4592 12.4182 18.5227 12.4182C17.1111 12.4182 16.1637 13.1928 15.777 13.9272H15.7362V12.6527H12.9519V21.9994H15.8511V17.3713C15.8511 16.1527 16.0821 14.9743 17.5912 14.9743C19.0781 14.9743 19.1002 16.365 19.1002 17.4494V22H21.9965ZM8.231 12.6533H11.1337V22H8.231V12.6533ZM9.68117 8C8.75308 8 8 8.75308 8 9.68117C8 10.6092 8.75308 11.3781 9.68117 11.3781C10.6092 11.3781 11.3623 10.6092 11.3623 9.68117C11.362 9.23539 11.1848 8.80796 10.8696 8.49274C10.5544 8.17753 10.1269 8.00031 9.68117 8Z"/>
  </mask>
  <path d="M21.9965 22L22 21.9994V16.8649C22 14.3531 21.4592 12.4182 18.5227 12.4182C17.1111 12.4182 16.1637 13.1928 15.777 13.9272H15.7362V12.6527H12.9519V21.9994H15.8511V17.3713C15.8511 16.1527 16.0821 14.9743 17.5912 14.9743C19.0781 14.9743 19.1002 16.365 19.1002 17.4494V22H21.9965ZM8.231 12.6533H11.1337V22H8.231V12.6533ZM9.68117 8C8.75308 8 8 8.75308 8 9.68117C8 10.6092 8.75308 11.3781 9.68117 11.3781C10.6092 11.3781 11.3623 10.6092 11.3623 9.68117C11.362 9.23539 11.1848 8.80796 10.8696 8.49274C10.5544 8.17753 10.1269 8.00031 9.68117 8Z" fill="#1E1E1E"/>
  <path d="M21.9965 22V27.3333H22.4376L22.8728 27.2609L21.9965 22ZM22 21.9994L22.8763 27.2603L27.3333 26.5179V21.9994H22ZM15.777 13.9272V19.2606H18.9961L20.496 16.4123L15.777 13.9272ZM15.7362 13.9272H10.4028V19.2606H15.7362V13.9272ZM15.7362 12.6527H21.0695V7.31933H15.7362V12.6527ZM12.9519 12.6527V7.31933H7.61858V12.6527H12.9519ZM12.9519 21.9994H7.61858V27.3328H12.9519V21.9994ZM15.8511 21.9994V27.3328H21.1844V21.9994H15.8511ZM19.1002 22H13.7669V27.3333H19.1002V22ZM8.231 12.6533V7.31992H2.89767V12.6533H8.231ZM11.1337 12.6533H16.467V7.31992H11.1337V12.6533ZM11.1337 22V27.3333H16.467V22H11.1337ZM8.231 22H2.89767V27.3333H8.231V22ZM9.68117 8L9.68486 2.66667H9.68117V8ZM11.3623 9.68117H16.6957L16.6957 9.67747L11.3623 9.68117ZM22.8728 27.2609L22.8763 27.2603L21.1237 16.7386L21.1202 16.7391L22.8728 27.2609ZM27.3333 21.9994V16.8649H16.6667V21.9994H27.3333ZM27.3333 16.8649C27.3333 15.4927 27.245 13.0325 25.8758 10.858C24.1507 8.11808 21.3077 7.08483 18.5227 7.08483V17.7515C18.6896 17.7515 18.4445 17.7809 18.0131 17.5755C17.5233 17.3425 17.112 16.9585 16.8493 16.5412C16.6262 16.1869 16.603 15.9576 16.6212 16.0585C16.6392 16.1582 16.6667 16.4005 16.6667 16.8649H27.3333ZM18.5227 7.08483C15.0426 7.08483 12.3251 9.03606 11.058 11.4422L20.496 16.4123C20.0024 17.3496 19.1796 17.7515 18.5227 17.7515V7.08483ZM15.777 8.59392H15.7362V19.2606H15.777V8.59392ZM21.0695 13.9272V12.6527H10.4028V13.9272H21.0695ZM15.7362 7.31933H12.9519V17.986H15.7362V7.31933ZM7.61858 12.6527V21.9994H18.2852V12.6527H7.61858ZM12.9519 27.3328H15.8511V16.6661H12.9519V27.3328ZM21.1844 21.9994V17.3713H10.5177V21.9994H21.1844ZM21.1844 17.3713C21.1844 17.2119 21.1939 17.2209 21.1767 17.3279C21.161 17.4256 21.0929 17.8062 20.8258 18.2908C20.5278 18.8313 20.0198 19.426 19.2663 19.8432C18.5437 20.2434 17.9072 20.3077 17.5912 20.3077V9.641C16.5206 9.641 15.2893 9.85258 14.0989 10.5118C12.8778 11.188 12.029 12.1535 11.4847 13.1409C10.5343 14.8647 10.5177 16.6644 10.5177 17.3713H21.1844ZM17.5912 20.3077C17.1116 20.3077 16.2652 20.1844 15.4028 19.5827C14.5518 18.989 14.1315 18.2407 13.9448 17.7693C13.8545 17.5414 13.8105 17.3605 13.7892 17.2562C13.7677 17.1508 13.762 17.0865 13.7614 17.0805C13.7608 17.0736 13.763 17.0962 13.7647 17.1637C13.7664 17.2338 13.7669 17.3167 13.7669 17.4494H24.4336C24.4336 17.1396 24.4964 15.4432 23.8618 13.8411C23.4837 12.8865 22.7791 11.7228 21.5057 10.8344C20.2209 9.93815 18.8142 9.641 17.5912 9.641V20.3077ZM13.7669 17.4494V22H24.4336V17.4494H13.7669ZM19.1002 27.3333H21.9965V16.6667H19.1002V27.3333ZM8.231 17.9866H11.1337V7.31992H8.231V17.9866ZM5.80033 12.6533V22H16.467V12.6533H5.80033ZM11.1337 16.6667H8.231V27.3333H11.1337V16.6667ZM13.5643 22V12.6533H2.89767V22H13.5643ZM9.68117 2.66667C5.80756 2.66667 2.66667 5.80756 2.66667 9.68117H13.3333C13.3333 11.6986 11.6986 13.3333 9.68117 13.3333V2.66667ZM2.66667 9.68117C2.66667 13.4899 5.74312 16.7114 9.68117 16.7114V6.04475C11.763 6.04475 13.3333 7.72859 13.3333 9.68117H2.66667ZM9.68117 16.7114C13.6192 16.7114 16.6957 13.4899 16.6957 9.68117H6.029C6.029 7.72859 7.59929 6.04475 9.68117 6.04475V16.7114ZM16.6957 9.67747C16.6944 7.81849 15.9553 6.03601 14.6408 4.72151L7.09835 12.264C6.41428 11.5799 6.02967 10.6523 6.029 9.68486L16.6957 9.67747ZM14.6408 4.72151C13.3263 3.40701 11.5438 2.66796 9.68486 2.66667L9.67747 13.3333C8.71004 13.3327 7.78243 12.9481 7.09835 12.264L14.6408 4.72151Z" fill="#1E1E1E" mask="url(#path-2-inside-1_314_1514)"/>
</svg>
  `
}

const TwitterIcon = {
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <circle cx="15" cy="15" r="14.5" stroke="#1E1E1E"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8614 8H7L12.7639 15.6134L7.36873 22H9.86144L13.942 17.1696L17.5654 21.9555H22.4268L16.4954 14.1209L16.5059 14.1345L21.6129 8.0889H19.1202L15.3276 12.5784L11.8614 8Z" fill="#1E1E1E"/>
</svg>
  `
}


const socialIcons = [
  {component: FacebookIcon, link: 'https://facebook.com'},
  {component: YoutubeIcon, link: 'https://youtube.com'},
  {component: LinkedinIcon, link: 'https://linkedin.com'},
  {component: TwitterIcon, link: 'https://x.com'},
];

const LocationIcon = {
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <path d="M15 1.875C12.266 1.87823 9.6448 2.96575 7.71153 4.89902C5.77826 6.83229 4.69074 9.45344 4.68751 12.1875C4.68424 14.4218 5.41406 16.5954 6.76501 18.375C6.76501 18.375 7.04626 18.7453 7.0922 18.7987L15 28.125L22.9116 18.7941C22.9528 18.7444 23.235 18.375 23.235 18.375L23.2359 18.3722C24.5862 16.5934 25.3157 14.4207 25.3125 12.1875C25.3093 9.45344 24.2218 6.83229 22.2885 4.89902C20.3552 2.96575 17.7341 1.87823 15 1.875ZM15 15.9375C14.2583 15.9375 13.5333 15.7176 12.9166 15.3055C12.2999 14.8935 11.8193 14.3078 11.5355 13.6226C11.2516 12.9373 11.1774 12.1833 11.3221 11.4559C11.4668 10.7285 11.8239 10.0603 12.3484 9.53585C12.8728 9.0114 13.541 8.65425 14.2684 8.50955C14.9959 8.36486 15.7499 8.43912 16.4351 8.72295C17.1203 9.00678 17.706 9.48743 18.118 10.1041C18.5301 10.7208 18.75 11.4458 18.75 12.1875C18.7488 13.1817 18.3533 14.1348 17.6503 14.8378C16.9473 15.5408 15.9942 15.9363 15 15.9375Z" fill="#0095DE"/>
</svg>
  `
}
const PhoneIcon = {
  template: `
   <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <path d="M25 13.7487H27.5C27.5 7.33625 22.6588 2.5 16.2375 2.5V5C21.315 5 25 8.67875 25 13.7487Z" fill="#0095DE"/>
  <path d="M16.2501 9.99999C18.8789 9.99999 20.0001 11.1212 20.0001 13.75H22.5001C22.5001 9.71874 20.2814 7.49999 16.2501 7.49999V9.99999ZM20.5276 16.8037C20.2874 16.5854 19.9718 16.469 19.6474 16.479C19.3229 16.4891 19.0151 16.6248 18.7889 16.8575L15.7976 19.9337C15.0776 19.7962 13.6301 19.345 12.1401 17.8587C10.6501 16.3675 10.1989 14.9162 10.0651 14.2012L13.1389 11.2087C13.3719 10.9827 13.5078 10.6748 13.5178 10.3503C13.5278 10.0257 13.4112 9.71004 13.1926 9.46999L8.57386 4.39124C8.35516 4.15044 8.05121 4.00437 7.72655 3.98407C7.40189 3.96376 7.08211 4.07082 6.83511 4.28249L4.12261 6.60874C3.9065 6.82564 3.77751 7.11431 3.76011 7.41999C3.74136 7.73249 3.38386 15.135 9.12386 20.8775C14.1314 25.8837 20.4039 26.25 22.1314 26.25C22.3839 26.25 22.5389 26.2425 22.5801 26.24C22.8858 26.2229 23.1743 26.0933 23.3901 25.8762L25.7151 23.1625C25.9269 22.9157 26.0342 22.596 26.0141 22.2713C25.9941 21.9467 25.8482 21.6426 25.6076 21.4237L20.5276 16.8037Z" fill="#0095DE"/>
</svg>
  `
}

const MailIcon = {
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <path d="M28 5H3V25H28V5ZM25.5 10L15.5 16.25L5.5 10V7.5L15.5 13.75L25.5 7.5V10Z" fill="#0095DE"/>
</svg>
  `
}

const ClockIcon = {
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <path d="M18.101 3.59097C18.1028 3.64852 18.0991 3.70612 18.0899 3.76296C18.0457 4.55257 17.7009 5.2953 17.1263 5.83867C16.5517 6.38203 15.7908 6.6848 15 6.6848C14.2092 6.6848 13.4483 6.38203 12.8737 5.83867C12.2991 5.2953 11.9543 4.55257 11.9101 3.76296C11.9009 3.70612 11.8972 3.64852 11.899 3.59097C11.899 2.76854 12.2257 1.97979 12.8073 1.39825C13.3888 0.816699 14.1776 0.48999 15 0.48999C15.8224 0.48999 16.6112 0.816699 17.1927 1.39825C17.7743 1.97979 18.101 2.76854 18.101 3.59097Z" fill="#0095DE"/>
  <path d="M12.4815 6.95264L8.35429 11.0799H4.59319L10.9504 4.72261C11.1984 5.61561 11.7372 6.40036 12.4815 6.95264Z" fill="#0095DE"/>
  <path d="M25.4068 11.0799H21.6457L17.5185 6.95264C18.2628 6.40036 18.8015 5.61561 19.0496 4.72261L25.4068 11.0799Z" fill="#0095DE"/>
  <path d="M28.9959 12.1893H1.00407C0.738618 12.189 0.483853 12.2939 0.295632 12.4811C0.107411 12.6682 0.00109684 12.9224 3.38714e-08 13.1879V28.8979C-3.42208e-05 29.0298 0.0259134 29.1604 0.0763605 29.2822C0.126807 29.404 0.200765 29.5147 0.294008 29.608C0.387251 29.7012 0.497953 29.7752 0.619787 29.8256C0.741622 29.8761 0.872202 29.902 1.00407 29.902H28.9959C29.1278 29.902 29.2584 29.8761 29.3802 29.8256C29.502 29.7752 29.6127 29.7012 29.706 29.608C29.7992 29.5147 29.8732 29.404 29.9236 29.2822C29.9741 29.1604 30 29.0298 30 28.8979V13.1879C29.9989 12.9224 29.8926 12.6682 29.7044 12.4811C29.5161 12.2939 29.2614 12.189 28.9959 12.1893ZM20.7522 19.0493L14.408 25.3934C14.1369 25.6659 13.7687 25.8196 13.3843 25.8205C13 25.8215 12.6309 25.6698 12.3584 25.3987L9.24186 22.2821C8.93794 21.975 8.76797 21.5601 8.76909 21.128C8.77021 20.696 8.94234 20.2819 9.24786 19.9764C9.55337 19.6709 9.96741 19.4988 10.3995 19.4976C10.8315 19.4965 11.2465 19.6665 11.5536 19.9704L13.3925 21.8093L18.4524 16.7494C18.6031 16.5972 18.7824 16.4762 18.9801 16.3935C19.1777 16.3108 19.3897 16.2679 19.6039 16.2674C19.8182 16.2669 20.0304 16.3087 20.2284 16.3904C20.4265 16.4722 20.6064 16.5922 20.7579 16.7437C20.9094 16.8952 21.0295 17.0751 21.1112 17.2732C21.1929 17.4712 21.2347 17.6834 21.2342 17.8977C21.2337 18.1119 21.1908 18.3239 21.1081 18.5216C21.0254 18.7192 20.9044 18.8985 20.7522 19.0493Z" fill="#0095DE"/>
</svg>
  `
}


const offices = [
  {
    title: 'Corporate Office',
    details: [
      {icon: LocationIcon, content: 'Suite 502, Navana DH Tower, 6 Panthapath, Dhaka-1215'},
      {icon: PhoneIcon, content: '+880 (2) 223 374053<br>+880 1678 086 272'},
      {icon: MailIcon, content: 'sales@safenet.com.bd'},
      {icon: ClockIcon, content: 'Saturday - Thursday: 9am to 6pm<br><span class="text-danger">Friday: Closed</span>'},
    ],
  },
  {
    title: 'Sales Center',
    details: [
      {icon: LocationIcon, content: 'SR-222/4 (2nd Floor) BCS Computer City, IDB Bhaban,  Dhaka-1207'},
      {icon: PhoneIcon, content: '+880 (2) 223 374053<br>+880 1678 086 272'},
      {icon: MailIcon, content: 'sales@safenet.com.bd'},
      {icon: ClockIcon, content: 'Saturday - Thursday: 9am to 6pm<br><span class="text-danger">Friday: Closed</span>'},
    ],
  },
];

const formFields = [
  {id: 'name', type: 'text', placeholder: 'Enter your name'},
  {id: 'email', type: 'email', placeholder: 'Enter your email'},
  {id: 'phone', type: 'tel', placeholder: 'Enter your phone number'},
  {id: 'company', type: 'text', placeholder: 'Enter your company name/address'},
  {id: 'message', type: 'textarea', placeholder: 'Write your message'},
];


const CopyIcon = {
  template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
  <circle cx="13.1025" cy="13" r="13" fill="white"/>
  <path d="M17.1025 13.9V18.1C17.1025 21.6 15.7025 23 12.2025 23H8.00254C4.50254 23 3.10254 21.6 3.10254 18.1V13.9C3.10254 10.4 4.50254 9 8.00254 9H12.2025C15.7025 9 17.1025 10.4 17.1025 13.9Z" fill="white"/>
  <path d="M23.1025 7.9V12.1C23.1025 15.6 21.7025 17 18.2025 17H17.1025V13.9C17.1025 10.4 15.7025 9 12.2025 9L9.10254 9V7.9C9.10254 4.4 10.5025 3 14.0025 3H18.2025C21.7025 3 23.1025 4.4 23.1025 7.9Z" fill="white"/>
  <path d="M17.1025 13.9V18.1C17.1025 21.6 15.7025 23 12.2025 23H8.00254C4.50254 23 3.10254 21.6 3.10254 18.1V13.9C3.10254 10.4 4.50254 9 8.00254 9H12.2025M17.1025 13.9C17.1025 10.4 15.7025 9 12.2025 9M17.1025 13.9V17H18.2025C21.7025 17 23.1025 15.6 23.1025 12.1V7.9C23.1025 4.4 21.7025 3 18.2025 3H14.0025C10.5025 3 9.10254 4.4 9.10254 7.9V9L12.2025 9" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  `
}

const socialtwoIcons = ref([
  {link: '#', component: CopyIcon}
]);
const formData = ref({
  name: '',
  email: '',
  phone: '',
  company: '',
  message: '',
});

const submitForm = () => {
  // Validate the form data before submission
  if (isFormValid()) {
    // Create a FormData object from the form data
    const formDataObject = new FormData();
    for (const [key, value] of Object.entries(formData.value)) {
      formDataObject.append(key, value);
    }

    // Example of form submission logic (using fetch API)
    fetch('/contact-save/', {
      method: 'POST',
      body: formDataObject, // Send as form data
    })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Form submission failed');
          }
          return response.json();
        })
        .then((data) => {
          console.log('Form submission successful:', data);
          // Optional: Handle success (e.g., show a success message)
        })
        .catch((error) => {
          console.error('Error during form submission:', error);
          // Optional: Handle error (e.g., show an error message)
        });
  } else {
    console.error('Form validation failed');
  }
};

// Example of form validation function
const isFormValid = () => {
  // Add your validation logic here
  // Example: Check if all required fields are filled
  return Object.values(formData.value).every((field) => field !== '');
};




</script>

<style scoped>
@font-face {
  font-family: 'Poppins';
  src: url('../assets/Poppins/Poppins-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Poppins';
  src: url('../assets/Poppins/Poppins-SemiBold.ttf') format('truetype');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Poppins';
  src: url('../assets/Poppins/Poppins-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
}


.map_side, .contact_side {
  width: 50%;
}

.share {
  color: #000;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  text-decoration: none;

}

.content_area {
  color: #1E1E1E;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  letter-spacing: 0.9px;
}

.breadcrumb {
  background: #F6F6F6;
  padding: 20px 80px;
}

.breadcrumb-item a {
  text-decoration: none;
  color: #1E1E1E;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.5px;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: '';
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border: solid #1E1E1E;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  margin-right: 0px;
  transform: rotate(-45deg);
  transition: transform 0.3s ease;
  height: 0;
  width: 0;
}

.connect-section {
  padding: 80px;
}

.connect-section h2 {
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  letter-spacing: 0.2px;
  margin-bottom: 20px;
  background: linear-gradient(91deg, #1AE5FE 14.22%, #105BCC 86.23%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header h2 {
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 52px */
  letter-spacing: 0.2px;
}

.header p {
  color: #000;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 175% */
  letter-spacing: 0.08px;
  max-width: 600px;
  margin-bottom: 10px;
}

.connect-section .form-group {
  margin-bottom: 20px;
}

.connect-section form button {
  padding: 10px 20px;
  border-radius: 5px;
}

.icon {
  margin-bottom: 60px;
}

.icon a {
  text-decoration: none;
}

.corporate h4 {
  color: #000;
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 100% */
  letter-spacing: 0.5px;
}

.corporate p {
  color: #1E1E1E;
  font-size: 18px;
  font-style: normal;
  font-weight: 350;
  line-height: 28px;
  letter-spacing: 0.9px;
  margin-bottom: 0px;
}

.send_btn {
  color: #FFF;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  border-radius: 53px !important;
  background: linear-gradient(180deg, #313131 0%, #1E1E1E 100%);
  box-shadow: 0px 6px 12px 0px rgba(201, 203, 208, 0.25);
  padding: 10px 48px !important;
}

.with_us {
  color: #000;
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 100% */
  letter-spacing: 0.5px;
}

.with_descrip {
  color: #1E1E1E;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.5px;
}

@media only screen and (max-width: 375px) {
  .map_side, .contact_side {
    width: 100%;
  }

  .connect-section {
    padding: 20px !important;
  }

  .connect-section h2 {
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 26px */
    letter-spacing: 0.1px;
    margin-bottom: 20px;
    background: linear-gradient(91deg, #1AE5FE 14.22%, #105BCC 86.23%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .header p {
    color: #1E1E1E;
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.06px;
    margin-bottom: 10px;
  }

  .corporate h4 {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
    letter-spacing: 0.5px;
  }

  .with_us {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
    letter-spacing: 0.5px;
  }

  .with_descrip {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.5px;
  }

  .content_area {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 200% */
    letter-spacing: 0.42px;
  }

}

@media only screen and (min-width: 376px) and (max-width: 425px) {
  .map_side, .contact_side {
    width: 100% !important;
  }

  .connect-section {
    padding: 20px !important;
  }

  .connect-section h2 {
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 26px */
    letter-spacing: 0.1px;
    margin-bottom: 20px;
    background: linear-gradient(91deg, #1AE5FE 14.22%, #105BCC 86.23%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .header p {
    color: #1E1E1E;
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.06px;
    margin-bottom: 10px;
  }

  .corporate h4 {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
    letter-spacing: 0.5px;
  }

  .with_us {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
    letter-spacing: 0.5px;
  }

  .with_descrip {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.5px;
  }

  .content_area {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 200% */
    letter-spacing: 0.42px;
  }

}

@media only screen and (min-width: 426px) and (max-width: 767px) {
  .map_side, .contact_side {
    width: 100% !important;
  }


  .connect-section {
    padding: 20px !important;
  }

  .connect-section h2 {
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 26px */
    letter-spacing: 0.1px;
    margin-bottom: 20px;
    background: linear-gradient(91deg, #1AE5FE 14.22%, #105BCC 86.23%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .header p {
    color: #1E1E1E;
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.06px;
    margin-bottom: 10px;
  }

  .corporate h4 {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
    letter-spacing: 0.5px;
  }

  .with_us {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
    letter-spacing: 0.5px;
  }

  .with_descrip {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.5px;
  }

  .content_area {
    color: #1E1E1E;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 200% */
    letter-spacing: 0.42px;
  }

}

@media only screen and  (min-width: 768px) and (max-width: 991px) {


  .cp {
    gap: 40px !important;
  }

  .connect-section {
    padding: 40px !important;
  }

}

@media only screen and (max-width: 1024px) {

}

@media only screen and (max-width: 1280px) {

}

@media only screen and (max-width: 1366px) {

}

@media only screen and (max-width: 1440px) {

}


</style>